var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69941 17.2407C7.40749 15.9257 7.45232 14.5584 7.82972 13.2654C8.20713 11.9724 8.9049 10.7956 9.85835 9.84413C10.8118 8.89268 11.99 8.19737 13.2838 7.82267C14.5776 7.44797 15.9451 7.40601 17.2594 7.70068C17.9828 6.56929 18.9794 5.6382 20.1573 4.99325C21.3352 4.34831 22.6565 4.01025 23.9994 4.01025C25.3423 4.01025 26.6636 4.34831 27.8415 4.99325C29.0194 5.6382 30.016 6.56929 30.7394 7.70068C32.0557 7.40473 33.4255 7.4465 34.7214 7.82211C36.0173 8.19772 37.1971 8.89497 38.1511 9.84899C39.1051 10.803 39.8024 11.9828 40.178 13.2787C40.5536 14.5745 40.5954 15.9443 40.2994 17.2607C41.4308 17.9841 42.3619 18.9807 43.0068 20.1586C43.6518 21.3365 43.9898 22.6578 43.9898 24.0007C43.9898 25.3436 43.6518 26.6649 43.0068 27.8428C42.3619 29.0207 41.4308 30.0173 40.2994 30.7407C40.5941 32.055 40.5521 33.4225 40.1774 34.7163C39.8027 36.0101 39.1074 37.1883 38.156 38.1418C37.2045 39.0952 36.0277 39.793 34.7347 40.1704C33.4417 40.5478 32.0744 40.5926 30.7594 40.3007C30.0369 41.4364 29.0396 42.3715 27.8597 43.0193C26.6798 43.6672 25.3555 44.0068 24.0094 44.0068C22.6634 44.0068 21.3391 43.6672 20.1592 43.0193C18.9793 42.3715 17.9819 41.4364 17.2594 40.3007C15.9451 40.5954 14.5776 40.5534 13.2838 40.1787C11.99 39.804 10.8118 39.1087 9.85835 38.1572C8.9049 37.2058 8.20713 36.029 7.82972 34.736C7.45232 33.443 7.40749 32.0756 7.69941 30.7607C6.55932 30.0392 5.62024 29.041 4.96951 27.8591C4.31878 26.6772 3.97754 25.3499 3.97754 24.0007C3.97754 22.6515 4.31878 21.3242 4.96951 20.1423C5.62024 18.9603 6.55932 17.9622 7.69941 17.2407Z",
    stroke: "#1B1A1B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 32V24",
    stroke: "#1B1A1B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15.9995H24.02",
    stroke: "#1B1A1B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeInfo);
export default __webpack_public_path__ + "static/media/badge-info.4610e14f22f106263aaea44906437f4c.svg";
export { ForwardRef as ReactComponent };